<template>
    <el-select class="wl-select input-with-select"
               v-model="myValue"
               :multiple="multi"
               @change="onValueChange"
               :placeholder="placeholder"
               :disabled="disabled"
               :collapse-tags="collapseTags"
               :clearable="clearable"
               :filterable="filterable"
            >
        <el-option v-for="item in options"
                   :key="item.value"
                   :label="i18n?$t(item.label):item.label"
                   :value="item.value">
        </el-option>
    </el-select>
</template>
<script>
  export default {
    data() {
      return {
        options: [],
        myValue: this.value,
        loading: false,
        multi: _.isArray(this.value)
      };
    },
    mounted() {
      this.initDropDown(this.defaultSelectAll);
    },
    methods: {
      initDropDown: async function (defaultSelectAll) {
        try {
          this.loading = true;
          let {code, data, success, errDetails} = await this.api();

          if (code == '1') {
            this.options = _.map(data, this.filter);

            if (defaultSelectAll) {
              this.onValueChange(_.map(this.options, v => v.value));
            }
          } else {
            this.$message.error(this.$t(code));
          }
        } finally {
          this.loading = false;
        }
      },
      onValueChange(v) {
        this.myValue = v;
        this.onChanage(v);
      },
      getOptionValue() {
        const _ids = this.multi ? this.myValue : [this.myValue];
        const chosen = _.filter(this.options, v => {
          const id = _.findIndex(_ids, v1 => v1 === v.value);
          return id !== -1;
        });
        return chosen;
      }
    },
    watch: {
      value(v) {
        this.myValue = v;
      },
      myValue(v) {
        this.$emit('input', v);
      }
    },
    props: {
      i18n: {
        type: Boolean,
        default: false
      },
      onChanage: {
        type: Function,
        default: () => {
        }
      },
      api: {
        type: Function,
        default: () => {
        }
      },
      placeholder: String,
      defaultSelectAll: {
        type: Boolean,
        default: false
      },
      value: {
        type: [String, Array, Number]
      },
      filter: {
        type: Function,
        default: v => v
      },
      disabled: {
        type: Boolean,
        default: false
      },
      collapseTags: {
        type: Boolean,
        default: true
      },
      clearable: {
        type: Boolean,
        default: true
      },
      filterable: {
        type: Boolean,
        default: false
      }
    }
  };
</script>

<style scoped>
    .wl-select {
        width: 220px;
    }
    .input-with-select ::v-deep  .el-input .el-input__inner{
        height: 30PX !important;
        line-height: 30PX;
    }
</style>
